"use client";

import { NavButton } from "@/components/nav-button";
import StatusContainer from "../components/containers/status-container";
import { montserrat } from "./fonts";
import { Logo } from "@/components/logo";

export const runtime = "edge";

export default function NotFound() {
  const loggedIn =
    document &&
    document.cookie.split(";").some((c) => c.trim().startsWith("logged_in="));

  return (
    <html className="h-svh" lang="en">
      <body
        className={`${montserrat.variable} flex h-full w-full flex-col justify-self-center pt-0`}
      >
        <div className="flex h-full flex-col md:gap-4">
          <div>
            <div className="flex justify-center align-middle">
              <div className="mx-auto">
                <Logo />
              </div>{" "}
            </div>
          </div>
          <div className="md:flex md:flex-col">
            <main>
              {" "}
              <StatusContainer
                title="Error 404"
                heading="Page not found"
                desc="Sorry the page you are looking for doesn't exist or has been moved. Please try a different page."
                button={
                  loggedIn ? (
                    <NavButton
                      href={new URL(
                        "/profile",
                        process.env.NEXT_PUBLIC_ACCOR_PLUS_URL,
                      ).toString()}
                    >
                      Back to profile
                    </NavButton>
                  ) : undefined
                }
              />
            </main>
          </div>
        </div>
      </body>
    </html>
  );
}
